export class ContactFormData {
  constructor(name = "", email = "", message = "") {
    this.name = name;
    this.email = email;
    this.message = message;
  }
}

export class ContactResponse {
  constructor(status = false, data = null) {
    this.status = status;
    this.data = data;
  }
}